import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3f91d918"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "flex-center",
  style: {
    "width": "80%",
    "margin-bottom": "1rem"
  }
};
const _hoisted_2 = {
  class: "flex-start",
  style: {
    "width": "90%"
  }
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-center",
  style: {
    "width": "100%",
    "height": "4rem",
    "font-size": "2rem",
    "font-weight": "bold",
    "font-style": "italic"
  }
}, null, -1));

const _hoisted_4 = {
  class: "flex-between",
  style: {
    "width": "100%",
    "height": "3rem",
    "align-items": "center"
  }
};
const _hoisted_5 = {
  style: {
    "font-size": "2rem",
    "font-weight": "bold"
  }
};
const _hoisted_6 = {
  class: "flex-start",
  style: {
    "font-size": "1.2rem"
  }
};
const _hoisted_7 = {
  style: {
    "width": "100%",
    "height": "16rem"
  }
};
const _hoisted_8 = {
  key: 0,
  style: {
    "padding-bottom": "1rem"
  }
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bi bi-file-earmark-richtext",
  style: {
    "float": "left",
    "font-size": "2rem",
    "margin-right": "0.5rem"
  }
}, null, -1));

const _hoisted_10 = {
  class: "flex-between",
  style: {
    "text-decoration": "underline",
    "color": "#999",
    "font-size": "0.7rem",
    "line-height": "1.5rem"
  }
};
const _hoisted_11 = ["onClick"];

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "bi bi-arrow-right"
}, null, -1));

const _hoisted_13 = {
  style: {
    "text-decoration": "underline"
  }
};
const _hoisted_14 = ["onClick"];

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "bi bi-arrow-right"
}, null, -1));

const _hoisted_16 = {
  key: 0,
  style: {
    "width": "50%",
    "padding": "2rem",
    "border-top": "2px solid #000",
    "border-bottom": "2px solid #000"
  }
};

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "height": "19rem"
  }
}, null, -1));

const _hoisted_18 = [_hoisted_17];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MultipleOption = _resolveComponent("MultipleOption");

  const _component_MultipleSelect = _resolveComponent("MultipleSelect");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalog, (_catalog, _catalogKey) => {
    return _openBlock(), _createElementBlock("div", _hoisted_2, [_hoisted_3, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_catalog.child, (_type, _typeKey, _typeIndex) => {
      return _openBlock(), _createElementBlock("div", {
        style: _normalizeStyle([{
          "width": "50%",
          "padding": "1rem",
          "border-top": "2px solid #000"
        }, {
          'border-right': (_typeIndex + 1) % 2 ? '2px solid #000' : '',
          'border-bottom': $options.hasBottom(_typeIndex, Object.keys(_catalog.child).length) ? '2px solid #000' : ''
        }])
      }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_type.title), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, _toDisplayString(_ctx._t("admin")) + ":", 1), _createVNode(_component_MultipleSelect, {
        modelValue: _type.person,
        "onUpdate:modelValue": $event => _type.person = $event,
        style: {
          "width": "6rem"
        },
        disabled: _ctx.user.is_readonly,
        onChange: $event => $options.changePerson(_type, $event),
        response: false
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.person, _person => {
          return _openBlock(), _createBlock(_component_MultipleOption, {
            value: _person.id
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_person.name), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 256))]),
        _: 2
      }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])])]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_type.questionSort, (_question, _questionIndex) => {
        return _openBlock(), _createElementBlock(_Fragment, null, [_questionIndex < 4 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("div", null, "by " + _toDisplayString(_ctx.getPersonName(_question.change_person_id)), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$moment(_question.changeTime).format('YYYY-MM-DD')), 1)]), _createElementVNode("div", {
          style: {
            "width": "100%",
            "word-wrap": "wrap",
            "word-break": "break-all",
            "text-align": "left",
            "cursor": "pointer",
            "font-weight": "bold"
          },
          onClick: $event => $options.clickQuestion(_question)
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_question.nav, (_nav, _navIndex) => {
          return _openBlock(), _createElementBlock(_Fragment, null, [_navIndex > 1 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("span", null, _toDisplayString(_nav.title), 1), _hoisted_12], 64)) : _createCommentVNode("", true)], 64);
        }), 256)), _createElementVNode("span", _hoisted_13, _toDisplayString(_question.title), 1)], 8, _hoisted_11)])) : _createCommentVNode("", true)], 64);
      }), 256))]), _createElementVNode("div", {
        style: {
          "width": "100%",
          "height": "2rem",
          "font-weight": "bold"
        },
        class: "view-all flex-center",
        onClick: $event => $options.clickViewAll(_type.nav)
      }, [_createTextVNode(_toDisplayString(_ctx._t('viewAll')), 1), _hoisted_15], 8, _hoisted_14)], 4);
    }), 256)), Object.keys(_catalog.child).length % 2 ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18)) : _createCommentVNode("", true)]);
  }), 256))]);
}